export default "__VITE_ASSET__DEgYTuEZ__"